import axios from 'axios';
import { clearAllListScroll } from '../hooks/listNavigation/listViewStorage';
import { clearTracedUser, reportSessionEvent } from '../utils/sessionTrace';

export const SESSION_STORAGE_KEYS = ['token', 'filters', 'i18nextLng'];

let logoutInProgress = false;

export function clearSession() {
  SESSION_STORAGE_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch {
      // iOS private mode / storage quota — best effort
    }
  });
  clearAllListScroll();
  delete axios.defaults.headers.common.Authorization;
}

export function isPublicAppPath(pathname = window.location.pathname) {
  return (
    pathname === '/login'
    || pathname.startsWith('/resetPassword/')
    || pathname.startsWith('/public/')
  );
}

/**
 * Clears the session and redirects to login with an explicit reason for the user.
 * @param {{ reason?: 'expired' | 'invalid' }} options
 */
export function forceLogout({ reason = 'expired' } = {}) {
  if (logoutInProgress) {
    return;
  }
  logoutInProgress = true;

  void reportSessionEvent('ui.logout', {
    level: 'warn',
    reason,
    path: typeof window !== 'undefined' ? window.location.pathname : '',
  });
  clearTracedUser();
  clearSession();

  if (!isPublicAppPath()) {
    window.location.replace(`/login?session=${encodeURIComponent(reason)}`);
  }
}

export function isLogoutInProgress() {
  return logoutInProgress;
}
